/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Select_Audio_FailedInputs */

const en_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error selecting audio file`)
};

const fr_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la sélection du fichier audio`)
};

const de_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Auswählen der Audiodatei`)
};

const it_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante la selezione del file audio`)
};

const ru_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при выборе аудиофайла.`)
};

const es_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al seleccionar el archivo de audio`)
};

const zh_cn2_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择音频文件时出错`)
};

const ja_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオファイルの選択中にエラーが発生しました`)
};

const hi_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो फ़ाइल चुनने में त्रुटि`)
};

const pt_pt2_audio_description_export_select_audio_failed = /** @type {(inputs: Audio_Description_Export_Select_Audio_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao selecionar o arquivo de áudio`)
};

/**
* | output |
* | --- |
* | "Error selecting audio file" |
*
* @param {Audio_Description_Export_Select_Audio_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_select_audio_failed = /** @type {((inputs?: Audio_Description_Export_Select_Audio_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Select_Audio_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_select_audio_failed(inputs)
	if (locale === "de") return de_audio_description_export_select_audio_failed(inputs)
	if (locale === "it") return it_audio_description_export_select_audio_failed(inputs)
	if (locale === "ru") return ru_audio_description_export_select_audio_failed(inputs)
	if (locale === "es") return es_audio_description_export_select_audio_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_select_audio_failed(inputs)
	if (locale === "ja") return ja_audio_description_export_select_audio_failed(inputs)
	if (locale === "hi") return hi_audio_description_export_select_audio_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_select_audio_failed(inputs)
	return en_audio_description_export_select_audio_failed(inputs)
});